import { OverflowMenuItem } from "@carbon/react";

export const View = (props) => {
  return <OverflowMenuItem {...props} />;
  // return <OverflowMenuItem {...props}>{props.children}</OverflowMenuItem>;
};
